<template>
  <main class="page plain">
    <page-header title="我的任务" :subtitle="'共 ' + total + ' 项'" back @back="back">
      <button class="icon-button" :disabled="fetching" aria-label="刷新任务" @click="reloadList">
        <app-icon name="refresh" />
      </button>
    </page-header>
    <div class="list-filters below-header">
      <div class="chips">
        <button v-for="item in filters" :key="item.key" class="chip" :class="{ active: filter === item.key }" @click="filter = item.key">
          {{ item.label }}
        </button>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished || !!error" @load="loadMore">
      <div v-if="shown.length" class="c-list" style="margin-top:12px">
        <router-link v-for="item in shown" :key="item.id" :to="'/task/edit/' + item.id" class="task-row">
          <div class="task-row-top">
            <h3>{{ item.title }}</h3>
            <span class="tag" :class="{ soft: !item.is_finish }">{{ item.is_finish ? '已完成' : '待完成' }}</span>
          </div>
          <p>{{ item.start_content }}</p>
          <time>截止 {{ item.end_time || '未设置' }}</time>
        </router-link>
      </div>
    </van-list>
    <p v-if="error" class="error-message">
      {{ error }}
      <button class="text-button" @click="loadMore">重试</button>
    </p>
    <button v-if="!finished && !fetching && !error" class="list-footer" @click="loadMore">加载更多任务</button>
    <div v-if="finished && !shown.length" class="empty-state">
      <app-icon name="task" />
      <strong>这一类没有任务</strong>
      <p>新的工作安排会出现在这里。</p>
    </div>
  </main>
</template>
<script>
import paged from '../../common/paged'
export default {
  mixins: [
    paged('/api/employee/task/list', 'tasks', function() {
      return {}
    })
  ],
  data() {
    return {
      filter: 'all',
      filters: [
        { key: 'all', label: '全部任务' },
        { key: 'pending', label: '待完成' },
        { key: 'done', label: '已完成' }
      ]
    }
  },
  methods: {
    back() {
      if (window.history.length > 1) this.$router.back()
      else this.$router.replace('/employee')
    }
  },
  computed: {
    shown() {
      return this.list.filter(
        item => this.filter === 'all' || (this.filter === 'done' ? item.is_finish : !item.is_finish)
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/task/index.vue